import { useEffect, useState } from 'react'
import Button from '../../components/Button';
import { Divider } from 'semantic-ui-react';
import { getTheCheckAdditionalCharges } from '../../utils/summaryCalculation';

type Props = {
  extraValueData: any[];
  getDataFromExtras: (extraValue: any[]) => void;
  setCurrentPage: () => void;
  extraValueLoaded: boolean;
  orgainzedExtraData: any[];
  setOrgainzedExtraData: (value: any[]) => void;
  reservation: any;
}

const Extras = ({ extraValueData, getDataFromExtras, setCurrentPage, extraValueLoaded, orgainzedExtraData, setOrgainzedExtraData, reservation }: Props) => {
  const [extraValue, setExtraValue] = useState<any[]>([]);


  const updateTheCheckAdjustment = () => {
    const orgainzedUpdatedExtraData = extraValue
      ?.filter((item: any) => {
        const additionalCharges = item?.additionalCharges?.filter((value: any) => !value.hideFromReservations);
        return additionalCharges?.length > 0;
      })
      ?.map((item: any) => {
        const additionalCharges = item?.additionalCharges?.map((value: any) => {
          const amountOrPercentage = (value.chargeType === "Amount"
            ? value?.anountOrPercentage
            : (reservation?.totalBasePriceBeforeDiscount *
              parseFloat(value?.anountOrPercentage)) /
            100);

          return {
            ...value,
            basePrice:
              value?.reservationAdditionalId > 0
                ? value?.basePrice
                : amountOrPercentage,
            amountOrPercentage: amountOrPercentage,
            isChecked: value?.mandatory ? true : value?.isChecked,
            reservationAdditionalId: 0
          }
        });

        return {
          ...item,
          additionalCharges
        };
      });

    setOrgainzedExtraData(orgainzedUpdatedExtraData);
    getDataFromExtras(getTheCheckAdditionalCharges(orgainzedUpdatedExtraData));
  }

  useEffect(() => {
    if (extraValue) {
      updateTheCheckAdjustment();
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extraValue]);

  useEffect(() => {
    if (extraValueLoaded) {
      const extraData = extraValueData?.map((item: any) => {
        const additionalCharges = item?.additionalCharges?.map((value: any) => {
          return {
            ...value,
            quantity: value?.quantity ?? 1,
            basePrice: value?.basePrice ?? 0,
            isChecked: value?.isChecked ?? false,
            reservationAdditionalId: 0
          }
        });

        return {
          ...item,
          additionalCharges
        };
      });
      setExtraValue(extraData);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extraValueLoaded])

  const handleTheExtraSubmit = async (categoryId: number, additionalChargeId: number, updateValue: any) => {
    const updatedExtraData = await Promise.all(
      orgainzedExtraData.map(async (item: any) => {
        if (item?.id !== categoryId) {
          return item;
        }

        const additionalCharges = await Promise.all(
          item?.additionalCharges?.map(async (value: any) => {
            if (value?.id !== additionalChargeId) {
              return value;
            }

            return updateValue;
          })
        );

        return {
          ...item,
          additionalCharges
        };
      })
    );

    setExtraValue(updatedExtraData);
    setOrgainzedExtraData(updatedExtraData);
    getDataFromExtras(getTheCheckAdditionalCharges(updatedExtraData));
  };


  return (
    <div className="w-full py-6 md:px-6">
      {orgainzedExtraData.map((item: any, index: number) => {
        const allMandatory = item?.additionalCharges?.every((v: any) => v?.mandatory);
        const allHidden = item?.additionalCharges?.every((v: any) => v?.hideFromReservations);
        if (allMandatory || allHidden) return null;

        return (
          <div key={index} className="mb-4">
            <div className="w-full mb-3">
              <span className="text-base md:text-lg font-semibold">{item?.categoryName}</span>

              {item?.additionalCharges
                ?.filter((v: any) => !v?.hideFromReservations && !v?.mandatory)
                ?.map((value: any, i: number) => (
                  <div
                    key={i}
                    className="flex flex-col md:flex-row justify-between items-start md:items-center bg-white border rounded-lg px-3 py-4 mt-2 shadow-sm gap-2"
                  >
                    <div className="flex flex-col md:flex-row md:items-center gap-1.5">
                      <span className="text-sm md:text-base font-medium">{value?.name}</span>
                      {value?.recommended && (
                        <span className="inline-flex text-xs px-3 py-[2px] rounded-xl font-semibold bg-[#D9F4D4] text-[#039855] border mt-1 md:mt-0">
                          Recommended
                        </span>
                      )}
                    </div>

                    <div className="flex items-center gap-2 mt-2 md:mt-0 border px-3 py-2 rounded text-sm font-semibold">
                      <input
                        type="checkbox"
                        className="cursor-pointer"
                        checked={value?.isChecked ?? false}
                        onChange={() =>
                          handleTheExtraSubmit(item?.id, value?.id, {
                            ...value,
                            isChecked: !value?.isChecked,
                          })
                        }
                      />
                      <span className="text-sm font-medium">
                        {value?.chargeType === 'Amount' ? '$' : ''}
                        {parseFloat(value?.anountOrPercentage)?.toFixed(2)}
                        {value?.chargeType === 'Amount' ? '' : '%'}{' '}
                        {value?.selectionType === 'Only One' ? 'One Time' : '/Day'}
                      </span>
                    </div>
                  </div>
                ))}
            </div>

            <Divider className="w-full" />
          </div>
        );
      })}

      <div className="mt-6 md:mt-8">
        <Button
          btnType="button"
          name="Next Step"
          height="12px"
          isBorderBtn={false}
          isProcessing={false}
          onClickHandler={() => {
            getDataFromExtras(getTheCheckAdditionalCharges(orgainzedExtraData));
            setCurrentPage();
          }}
        />
      </div>
    </div>
  )
}

export default Extras